// Copyright (c) 2016 Deere & Company

import FailurePanelContainer from './failure-panel-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.normal.claim,
    downTimeCollection: state.claims.downTime,
    failureModes: state.claims.normal.failureModes,
    formValidation: state.claims.normal.formValidation,
    goodsInstallationVatOptions: state.claims.goodsInstallationVatOptions,
    isEditable: state.claims.normal.isEditable,
    isValidClaim: state.claims.normal.isValidClaim,
    showApplyTravel: state.claims.normal.showApplyTravel
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(FailurePanelContainer);



// WEBPACK FOOTER //
// ./src/claim/normal/components/failure-panel/index.js